import G6 from '@antv/g6';
import { ModelConfig } from '@antv/g6';
import { colorMap } from 'theme';
import { colors } from 'theme/theme2/colors';

import { resourceIcons, iconSwitch } from 'components/Icons';
import { setItemState } from 'components/Visualization/Graphs/nodes/setItemState';

import { RESOURCE_TYPE_NODE } from './nodes_types';

export function registerResourceTypeNode() {
  G6.registerNode(
    RESOURCE_TYPE_NODE,
    {
      setState(name, value, item) {
        setItemState(name, value, item);
      },
      //@ts-ignore
      draw(cfg?: ModelConfig, group?: IGroup) {
        const container = group.addShape(
          'rect',
          {
            attrs: {
              width: 200,
              height: 45,
              fill: colors.white,
              stroke: colorMap.primary(200),
              lineWidth: 0.5,
              shadowColor: '#999',
              shadowBlur: 21,
              shadowOffsetY: 10,
              opacity: 1,
              radius: 8,
            },
          },
          'container',
        );

        const { x = 0, y = 0, width = 0, height = 0 } = container.getBBox();

        // @ts-ignore
        let img = iconSwitch(cfg?.data?.resource_type, resourceIcons);
        // console.log(cfg?.data?.resourceType);

        group.addShape('image', {
          attrs: {
            x: x + 13,
            y: y + 13,
            width: 20,
            height: 20,
            img: img,
          },
          name: 'img',
        });

        group.addShape('text', {
          attrs: {
            x: x + 110,
            y: height / 2 - 2,
            textAlign: 'center',
            // @ts-ignore
            text: `${cfg?.data?.resource_type} / ${cfg?.data?.service}`, // cfg.data : typescript throws Object is of type 'unknow'
            fontSize: 12,
            opacity: 1,
            // fontStyle: 'bold',
            fill: colors.black,
            cursor: 'pointer',
          },
          name: 'type',
        });

        group.addShape('text', {
          attrs: {
            x: x + 75,
            y: height / 2 + 15,
            // @ts-ignore
            text: `[${cfg?.data?.instance_count} instances]`, // cfg.data : typescript throws Object is of type 'unknow'
            fontSize: 12,
            opacity: 1,
            // fontStyle: 'bold',
            fill: colors.black,
            cursor: 'pointer',
          },
          name: 'guid',
        });

        return container;
      },
      getAnchorPoints(cfg) {
        return [
          [0, 0.5],
          [1, 0.5],
        ];
      },
    },

    'rect',
  );
}
